import PlayerUserLimitsManage from './PlayerUserLimitsManage.svelte';


import CoolOff from './limits/coolOff.svelte';
import SelfExclusion from './limits/selfExclusion.svelte';
import CumulativeLimit from './limits/cumulativeLossLimit.svelte';
import DepositLimit from './limits/depositLimit.svelte';
import LossLimit from './limits/lossLimit.svelte';
import MaxStake from './limits/maxStake.svelte';
import PaymentLimit from './limits/paymentLimit.svelte';
import SessionLimit from './limits/sessionLimit.svelte';
import SportsLimit from './limits/SportLimit.svelte';
import WageringLimit from './limits/wageringLimit.svelte';

!customElements.get('cool-off') && customElements.define('cool-off', CoolOff);
!customElements.get('self-exclusion') && customElements.define('self-exclusion', SelfExclusion);
!customElements.get('cumulative-limit') && customElements.define('cumulative-limit', CumulativeLimit);
!customElements.get('deposit-limit') && customElements.define('deposit-limit', DepositLimit);
!customElements.get('loss-limit') && customElements.define('loss-limit', LossLimit);
!customElements.get('max-stake') && customElements.define('max-stake', MaxStake);
!customElements.get('payment-limit') && customElements.define('payment-limit', PaymentLimit);
!customElements.get('session-limit') && customElements.define('session-limit', SessionLimit);
!customElements.get('sport-limit-manage') && customElements.define('sport-limit-manage', SportsLimit);
!customElements.get('wagering-limit') && customElements.define('wagering-limit', WageringLimit);


!customElements.get('player-user-limits-manage') && customElements.define('player-user-limits-manage', PlayerUserLimitsManage);
export default PlayerUserLimitsManage;
